import { css } from '@microsoft/fast-element';
import { MainStyles } from '../../../../main/main.styles';
import { mixinRobotoMedium, mixinRobotoRegular } from '../../../../styles';
import WizardArrow from '../../../../assets/wizard-arrow.svg';

export const AnalyticsWizardStyles = css`
  ${MainStyles}
  :host {
    display: contents;
  }

  .wizard-wrapper {
    display: flex;
    width: 100%;
    background-color: #25282e;
    height: 36px;
    align-items: center;
    gap: 10px;
    padding: 0 16px;
    counter-reset: line-number;
  }

  .step {
    counter-increment: line-number;
  }

  .step span {
    opacity: 0.3;
    font-size: 12px;
    color: var(--white);
    ${mixinRobotoMedium()}
  }

  .step.selected span,
  .step.selected::before,
  .step.no-click.selected span,
  .step.no-click.selected::before,
  .step.no-click.selected:hover span,
  .step.no-click.selected:hover::before,
  .step:hover span,
  .step:hover::before {
    opacity: 1;
  }

  .step.no-click:hover span,
  .step.no-click:hover::before {
    opacity: 0.3;
  }

  .step:hover {
    cursor: pointer;
  }

  .step.no-click:hover {
    cursor: default;
  }

  .step::before {
    display: inline-flex;
    content: counter(line-number);
    border: 1px solid #23f0a6;
    color: #23f0a6;
    opacity: 0.3;
    width: 20px;
    height: 20px;
    justify-content: center;
    align-items: center;
    border-radius: 25px;
    font-size: 12px;
    margin-right: 12px;
    ${mixinRobotoRegular}
  }

  .step:first-child::after,
  .step:nth-child(2)::after {
    content: '';
    display: inline-flex;
    background: url(${WizardArrow}) no-repeat;
    width: 20px;
    height: 12px;
    margin: 0 20px;
  }
`;
